<template>
  <div
    class="sc-1q5lmzx-0 hDcCcd h-auto position-relative"
    v-for="item in props.list"
    :key="item.id"
    style=""
  >
    <div class="bg-white px-2 pt-1" >
      <!-- کلید روی محصول -->
      <button-template
        v-if="!item.store_active"
        :id="item.id"
        :sid="item.place_id || item.store_place_id"
        :quantity="item.quantity"
        origin="product"
      />
      <!-- فروشگاه بسته است -->
      <span
        v-else
        class="product-new-top bg-red w-100 d-flex bg-secondary"
        style="height: 24px; justify-content: center; align-items: center;font-size: 11px"
        >فروشگاه بسته است</span
      >
      <div @click="goProductPage(item.id)">
        <figure class="sc-1q5lmzx-2 ktLvGN thumbnail-Wrapper">
          <img
            :src="'https://radap.ir/' + item.img_url.split(',')[0]"
            class="product-img"
            :alt="item.stuff_name || item.name"
            loading="lazy"
          />
          <span class="product-name">{{ item.stuff_name || item.name }}</span>
          <span class="product-description text-muted">{{
            item.description
          }}</span>
        </figure>
      </div>
      <!-- قیمت محصول -->
      <footer class="pb-1">
        <!-- تخفیف اگر داشت -->
        <div
          :class="{ visible: item.discount > 0, invisible: item.discount == 0 }"
        >
          <div>
            <del class="small pe-1 text-muted">{{
              convertToPersian(numberFormat(item.price))
            }}</del>
            <label
              class="p--5 product-discount" style="color: red;"
              :class="{ 'peculiar-discount': item.discount > 4 }"
              >%{{ convertToPersian(item.discount) }}</label
            >
          </div>
        </div>
        <div>
          <strong>{{
            convertToPersian(
              numberFormat(
                parseInt(removeCommos(item.price)) -
                  parseInt(removeCommos(item.price)) *
                    (parseInt(item.discount) / 100)
              )
            )
          }}</strong>
          <small>تومان</small>
        </div>
      </footer>
    </div>
  </div>
</template>
<script setup>
import { defineProps } from "vue";
import ButtonTemplate from "./button.vue";
import router from "@/router";
import {
  convertToPersian,
  numberFormat,
  removeCommos,
} from "@/composables/digits";
let props = defineProps(["list"]);
import { useModal } from '@/store/modal';
const modalStore = useModal();
function goProductPage(id) {
  console.log('sdfsf');
  
  modalStore.open('productModal')
  modalStore.paylode.id = id
  // document.getElementById('ProductModalBTN').click()
  // router.push({ name: "Single", params: { item: id } });
}
</script>
<style scoped>
.heMFVq > * {
  margin: 1px !important;
  width: 100%;
}
@media (max-width: 950px) {
  .heMFVq > * {
    width: 32%;
  }
}
@media (max-width: 450px) {
  .heMFVq > * {
    width: 49%;
  }
}

.product-description {
  height: 22px;
  font-size: 11px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: black;
  font-family: "IranSans";
}
.product-img {
  width: 100%;
  margin-inline: auto;
  aspect-ratio: 1;
}
.product-discount {
  border: 1px solid red;
  line-height: 1.1;
  font-size: 12px;
  font-weight: 700;
  border-radius: 4px;
}
.p--5 {
  padding: 0.25em 0.125em;
}
.hDcCcd{
  border: unset !important;
  border-left: 1px solid #dee2e6 !important;
  margin: 0 !important;
  width: 150px !important;
  min-width: 150px !important;
  max-width: 150px !important;
}
</style>
